module.exports = __webpack_public_path__ + "img/za.8dc48856.svg";